import React from 'react'
import { Container, Row, Image } from 'react-bootstrap';

const ToS = () => {
    return (
        <Container>
            <Row className="justify-content-md-center">
                <h1>Terms of Service</h1>
            </Row>
            <Row>
                <p>Welcome to our Terms of Service. Please read these terms carefully before using our website.</p>
                <h2>1. Acceptance of Terms</h2>
                <p>By accessing and using our website, you accept and agree to be bound by the terms and provision of this agreement.</p>
                <h2>2. Modification of Terms</h2>
                <p>We reserve the right to modify these terms at any time. Your continued use of the site after any such changes constitutes your acceptance of the new terms.</p>
                <h2>3. Use of the Site</h2>
                <p>You agree to use the site only for lawful purposes and in a way that does not infringe the rights of, restrict or inhibit anyone else's use and enjoyment of the site.</p>
                <h2>4. Intellectual Property</h2>
                <p>All content on this site, including text, graphics, logos, and images, is the property of the site owner and is protected by copyright laws.</p>
                <h2>5. Limitation of Liability</h2>
                <p>In no event shall the site owner be liable for any damages arising out of or in connection with the use of this site.</p>
                <h2>6. Governing Law</h2>
                <p>These terms shall be governed by and construed in accordance with the laws of the jurisdiction in which the site owner resides.</p>
            </Row>
        </Container>
    );
};

export default ToS;